// extracted by mini-css-extract-plugin
export var basicPage = "basic-page_cE4qX003DU9ru6loHxvQ";
export var basicPageContent = "basic-page__content_FNXVjpd6Rs87vHtW388g";
export var basicPageControlHeader = "basic-page__control-header_HLdBYucmCJjkacYJNimT";
export var basicPageControlHeaderSticky = "basic-page__control-header-sticky_z5J1ONvPzEm2J3MrGplQ";
export var basicPageHeader = "basic-page__header_hp2crGS2pkVNQlpOYtw6";
export var basicPageLoadingContainer = "basic-page__loading-container_hMULje8CDlDklfDZiwwJ";
export var basicPageTitle = "basic-page__title_w1BIwm11DgAMh_EF2nUx";